// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-pos-action {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: var(--btn-pos-action-width);
  min-width: var(--chakra-sizes-10);
  border: none;
  border-radius: var(--chakra-radii-md);
  box-shadow: var(--chakra-shadows-sm);
  background: var(--chakra-colors-primary);
  color: var(--chakra-colors-white);
  font-family: inherit;
  font-size: var(--chakra-font-sizes-sm);
  font-weight: var(--chakra-font-weights-medium);
  line-height: 1.25rem;
  text-align: center;
  white-space: nowrap;
  overflow-wrap: break-word;
  overflow: hidden;
  isolation: isolate;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  appearance: none;
  -webkit-appearance: none;
  transition-property: filter, transform;
  transition-duration: 0.05s;
  transition-timing-function: ease;
}
@media (hover: hover) {
  .btn-pos-action:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {
    background: var(--chakra-colors-primary-_hover);
  }
}
.btn-pos-action:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {
  background: var(--chakra-colors-primary-_active);
  transform: scale(0.97);
}
.btn-pos-action:is(:disabled, [disabled], [data-disabled], [aria-disabled='true']) {
  opacity: 0.4;
  cursor: not-allowed;
}
.btn-pos-action-hidden {
  visibility: hidden;
}
.btn-pos-action-secondary {
  background: var(--chakra-colors-secondary);
}
@media (hover: hover) {
  .btn-pos-action-secondary:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {
    background: var(--chakra-colors-secondary-_hover);
  }
}
.btn-pos-action-secondary:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {
  background: var(--chakra-colors-secondary-_active);
}
.btn-pos-action-success {
  background: var(--chakra-colors-success);
}
@media (hover: hover) {
  .btn-pos-action-success:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {
    background: var(--chakra-colors-success-_hover);
  }
}
.btn-pos-action-success:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {
  background: var(--chakra-colors-success-_active);
}
.btn-pos-action-large.btn-pos-action-category {
  border-left: 0.3125rem solid var(--btn-pos-action-category-color);
}
.btn-pos-action-phone.btn-pos-action-category {
  border-bottom: 0.3125rem solid var(--btn-pos-action-category-color);
}
.btn-pos-action-large,
.btn-pos-action-metrics-large {
  --btn-pos-action-width: var(--chakra-sizes-24);
}
.btn-pos-action-large.btn-pos-action-edit-line,
.btn-pos-action-metrics-large.btn-pos-action-metrics-edit-line {
  --btn-pos-action-width: var(--chakra-sizes-49);
}
.btn-pos-action-phone,
.btn-pos-action-metrics-phone {
  --btn-pos-action-width: var(--chakra-sizes-12);
}
.btn-pos-action-phone.btn-pos-action-edit-line,
.btn-pos-action-metrics-phone.btn-pos-action-metrics-edit-line {
  --btn-pos-action-width: var(--chakra-sizes-40\\.5);
}
.btn-pos-action-large {
  height: var(--chakra-sizes-18);
  padding: var(--chakra-spacing-2);
  gap: var(--chakra-spacing-1);
}
.btn-pos-action-large.btn-pos-action-actions-grid,
.btn-pos-action-large.btn-pos-action-sales-screen {
  padding: 0 var(--chakra-spacing-2);
  gap: 0;
}
.btn-pos-action-large.btn-pos-action-edit-line {
  height: var(--chakra-sizes-10);
  padding: 0 var(--chakra-spacing-2);
  gap: var(--chakra-spacing-3);
  flex-direction: row;
  justify-content: flex-start;
}
.btn-pos-action-large .btn-pos-action-icon {
  width: var(--chakra-sizes-8);
  height: var(--chakra-sizes-8);
}
.btn-pos-action-large.btn-pos-action-edit-line .btn-pos-action-icon {
  width: var(--chakra-sizes-6);
  height: var(--chakra-sizes-6);
}
.btn-pos-action-large .btn-pos-action-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-height: var(--chakra-sizes-8);
  font-size: var(--chakra-font-sizes-xs);
  font-weight: var(--chakra-font-weights-semibold);
  line-height: normal;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
}
.btn-pos-action-phone {
  height: var(--chakra-sizes-12);
  padding: var(--chakra-spacing-1);
  gap: var(--chakra-spacing-1);
  flex: initial;
}
.btn-pos-action-phone.btn-pos-action-success {
  width: var(--chakra-sizes-18);
}
.btn-pos-action-phone.btn-pos-action-edit-line {
  height: var(--chakra-sizes-10);
  padding: 0 var(--chakra-spacing-1);
  gap: var(--chakra-spacing-3);
  flex-direction: row;
  justify-content: flex-start;
}
.btn-pos-action-phone .btn-pos-action-icon {
  width: var(--chakra-sizes-8);
  height: var(--chakra-sizes-8);
}
.btn-pos-action-phone.btn-pos-action-edit-line .btn-pos-action-icon {
  width: var(--chakra-sizes-6);
  height: var(--chakra-sizes-6);
}
.btn-pos-action-phone .btn-pos-action-text {
  display: flex;
  align-items: center;
  max-height: 2.4em;
  font-size: var(--chakra-font-sizes-xs);
  font-weight: var(--chakra-font-weights-semibold);
  line-height: 120%;
  white-space: normal;
}
.btn-pos-action-phone.btn-pos-action-edit-line .btn-pos-action-text {
  line-height: 118%;
  text-align: left;
}
.btn-pos-action-icon {
  display: block;
  flex-shrink: 0;
}
img.btn-pos-action-icon {
  object-fit: cover;
}
.btn-pos-action-fn {
  position: absolute;
  top: var(--chakra-spacing-2);
  right: var(--chakra-spacing-2);
  display: block;
  font-size: var(--chakra-font-sizes-2xs);
  font-weight: var(--chakra-font-weights-semibold);
  line-height: 120%;
  text-align: right;
  color: var(--chakra-colors-white);
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/pos-action-button.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,iCAAiC;EACjC,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,wCAAwC;EACxC,iCAAiC;EACjC,oBAAoB;EACpB,sCAAsC;EACtC,8CAA8C;EAC9C,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE;IACE,+CAA+C;EACjD;AACF;AACA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,iDAAiD;EACnD;AACF;AACA;EACE,kDAAkD;AACpD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE;IACE,+CAA+C;EACjD;AACF;AACA;EACE,gDAAgD;AAClD;AACA;EACE,iEAAiE;AACnE;AACA;EACE,mEAAmE;AACrE;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,iDAAiD;AACnD;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;;EAEE,kCAAkC;EAClC,MAAM;AACR;AACA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;EACtC,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,gDAAgD;EAChD,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;EACd,uCAAuC;EACvC,gDAAgD;EAChD,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;AACnC","sourcesContent":[".btn-pos-action {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: var(--btn-pos-action-width);\n  min-width: var(--chakra-sizes-10);\n  border: none;\n  border-radius: var(--chakra-radii-md);\n  box-shadow: var(--chakra-shadows-sm);\n  background: var(--chakra-colors-primary);\n  color: var(--chakra-colors-white);\n  font-family: inherit;\n  font-size: var(--chakra-font-sizes-sm);\n  font-weight: var(--chakra-font-weights-medium);\n  line-height: 1.25rem;\n  text-align: center;\n  white-space: nowrap;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  isolation: isolate;\n  cursor: pointer;\n  touch-action: manipulation;\n  user-select: none;\n  -webkit-user-select: none;\n  appearance: none;\n  -webkit-appearance: none;\n  transition-property: filter, transform;\n  transition-duration: 0.05s;\n  transition-timing-function: ease;\n}\n@media (hover: hover) {\n  .btn-pos-action:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {\n    background: var(--chakra-colors-primary-_hover);\n  }\n}\n.btn-pos-action:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {\n  background: var(--chakra-colors-primary-_active);\n  transform: scale(0.97);\n}\n.btn-pos-action:is(:disabled, [disabled], [data-disabled], [aria-disabled='true']) {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.btn-pos-action-hidden {\n  visibility: hidden;\n}\n.btn-pos-action-secondary {\n  background: var(--chakra-colors-secondary);\n}\n@media (hover: hover) {\n  .btn-pos-action-secondary:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {\n    background: var(--chakra-colors-secondary-_hover);\n  }\n}\n.btn-pos-action-secondary:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {\n  background: var(--chakra-colors-secondary-_active);\n}\n.btn-pos-action-success {\n  background: var(--chakra-colors-success);\n}\n@media (hover: hover) {\n  .btn-pos-action-success:is(:hover, [data-hover]):not(:disabled, [data-disabled]) {\n    background: var(--chakra-colors-success-_hover);\n  }\n}\n.btn-pos-action-success:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state='open']) {\n  background: var(--chakra-colors-success-_active);\n}\n.btn-pos-action-large.btn-pos-action-category {\n  border-left: 0.3125rem solid var(--btn-pos-action-category-color);\n}\n.btn-pos-action-phone.btn-pos-action-category {\n  border-bottom: 0.3125rem solid var(--btn-pos-action-category-color);\n}\n.btn-pos-action-large,\n.btn-pos-action-metrics-large {\n  --btn-pos-action-width: var(--chakra-sizes-24);\n}\n.btn-pos-action-large.btn-pos-action-edit-line,\n.btn-pos-action-metrics-large.btn-pos-action-metrics-edit-line {\n  --btn-pos-action-width: var(--chakra-sizes-49);\n}\n.btn-pos-action-phone,\n.btn-pos-action-metrics-phone {\n  --btn-pos-action-width: var(--chakra-sizes-12);\n}\n.btn-pos-action-phone.btn-pos-action-edit-line,\n.btn-pos-action-metrics-phone.btn-pos-action-metrics-edit-line {\n  --btn-pos-action-width: var(--chakra-sizes-40\\.5);\n}\n.btn-pos-action-large {\n  height: var(--chakra-sizes-18);\n  padding: var(--chakra-spacing-2);\n  gap: var(--chakra-spacing-1);\n}\n.btn-pos-action-large.btn-pos-action-actions-grid,\n.btn-pos-action-large.btn-pos-action-sales-screen {\n  padding: 0 var(--chakra-spacing-2);\n  gap: 0;\n}\n.btn-pos-action-large.btn-pos-action-edit-line {\n  height: var(--chakra-sizes-10);\n  padding: 0 var(--chakra-spacing-2);\n  gap: var(--chakra-spacing-3);\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.btn-pos-action-large .btn-pos-action-icon {\n  width: var(--chakra-sizes-8);\n  height: var(--chakra-sizes-8);\n}\n.btn-pos-action-large.btn-pos-action-edit-line .btn-pos-action-icon {\n  width: var(--chakra-sizes-6);\n  height: var(--chakra-sizes-6);\n}\n.btn-pos-action-large .btn-pos-action-text {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  max-height: var(--chakra-sizes-8);\n  font-size: var(--chakra-font-sizes-xs);\n  font-weight: var(--chakra-font-weights-semibold);\n  line-height: normal;\n  white-space: normal;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.btn-pos-action-phone {\n  height: var(--chakra-sizes-12);\n  padding: var(--chakra-spacing-1);\n  gap: var(--chakra-spacing-1);\n  flex: initial;\n}\n.btn-pos-action-phone.btn-pos-action-success {\n  width: var(--chakra-sizes-18);\n}\n.btn-pos-action-phone.btn-pos-action-edit-line {\n  height: var(--chakra-sizes-10);\n  padding: 0 var(--chakra-spacing-1);\n  gap: var(--chakra-spacing-3);\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.btn-pos-action-phone .btn-pos-action-icon {\n  width: var(--chakra-sizes-8);\n  height: var(--chakra-sizes-8);\n}\n.btn-pos-action-phone.btn-pos-action-edit-line .btn-pos-action-icon {\n  width: var(--chakra-sizes-6);\n  height: var(--chakra-sizes-6);\n}\n.btn-pos-action-phone .btn-pos-action-text {\n  display: flex;\n  align-items: center;\n  max-height: 2.4em;\n  font-size: var(--chakra-font-sizes-xs);\n  font-weight: var(--chakra-font-weights-semibold);\n  line-height: 120%;\n  white-space: normal;\n}\n.btn-pos-action-phone.btn-pos-action-edit-line .btn-pos-action-text {\n  line-height: 118%;\n  text-align: left;\n}\n.btn-pos-action-icon {\n  display: block;\n  flex-shrink: 0;\n}\nimg.btn-pos-action-icon {\n  object-fit: cover;\n}\n.btn-pos-action-fn {\n  position: absolute;\n  top: var(--chakra-spacing-2);\n  right: var(--chakra-spacing-2);\n  display: block;\n  font-size: var(--chakra-font-sizes-2xs);\n  font-weight: var(--chakra-font-weights-semibold);\n  line-height: 120%;\n  text-align: right;\n  color: var(--chakra-colors-white);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
